'use client';
import React, { useEffect, useState } from 'react';
import { Ada } from '../Ada';
import { ZenDesk } from '../ZenDesk';
import useFeature from '@/hooks/useFeature';
import { WhatsAppWidget } from '@/components/common/WhatsAppWidget';

const ChatbotWidget = () => {
  const enableAda = Boolean(useFeature('retention-enable-ada'));
  const retentionEnableWhatsAppWidget = useFeature(
    'retention-enable-whats-app-widget',
  );
  const region: string = process.env.NEXT_PUBLIC_REGION as string;
  const whatsAppRegions: Set<string> = new Set(['EU', 'UK']);
  const enableWhatsApp: boolean = whatsAppRegions.has(region);
  const [isAda, setIsAda] = useState(false);

  useEffect(() => {
    setIsAda(enableAda);
  }, [enableAda]);

  if (enableWhatsApp && retentionEnableWhatsAppWidget) {
    return <WhatsAppWidget />;
  } else {
    return isAda ? <Ada /> : <ZenDesk />;
  }
};

export default ChatbotWidget;
